export default "__VITE_ASSET__CGQUynDH__"